var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dg-page-header" }, [
    _c("header", { staticClass: "menu-header ant-layout-header" }, [
      _c("a", {
        staticClass: "goto",
        style: "background: url(" + _vm.bgUrl + ") 65% 50% / 100% no-repeat;",
        attrs: { href: "#" },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "horizontalMenu" }),
      _vm._v(" "),
      _c("div", { staticClass: "head-portrait" }, [
        _c("div", { staticClass: "user-header" }, [
          _c("img", {
            staticClass: "user-log-img",
            attrs: {
              src: "../../assets/TB1u365d4jaK1RjSZFAXXbdLFXa-48-48.jpg",
              alt: "加载中",
            },
            on: { click: _vm.showUserList },
          }),
          _vm._v(" "),
          _c(
            "i",
            {
              staticClass: "anticon anticon-caret-down",
              attrs: { "aria-label": "图标: caret-down" },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 1024 1024",
                    focusable: "false",
                    "data-icon": "caret-down",
                    width: "1em",
                    height: "1em",
                    fill: "currentColor",
                    "aria-hidden": "true",
                  },
                  on: { click: _vm.showUserList },
                },
                [
                  _c("path", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.userListShow,
                        expression: "userListShow",
                      },
                    ],
                    attrs: {
                      d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.userListShow,
                        expression: "!userListShow",
                      },
                    ],
                    attrs: {
                      d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.userListShow,
                expression: "userListShow",
              },
            ],
            staticClass: "user-list",
          },
          [
            _c("div", { staticClass: "list-conents-new" }, [
              _c("header", [
                _c("div", { staticClass: "user-logo" }, [
                  _c("img", {
                    staticClass: "user-log-img",
                    attrs: {
                      src:
                        "/dc/static/original/" +
                        _vm.$styleVars.themeImgType +
                        "/" +
                        _vm.item.OBJ_TYPE +
                        ".png",
                      alt: "加载中",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "userName-box" },
                  [
                    _c("div", { staticClass: "header-user-name" }, [
                      _vm._v(_vm._s(_vm.username)),
                    ]),
                    _vm._v(" "),
                    _vm.roles && _vm.roles.length > 0
                      ? _vm._l(_vm.roles, function (name) {
                          return _c("div", { key: name }, [
                            _vm._v(_vm._s(name)),
                          ])
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sign-out", on: { click: _vm.dropOut } },
                [_vm._v("退出登录")]
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "#" } }, [
      _c("span", { staticClass: "ali-name" }, [
        _vm._v("河钢集团主数据管理平台"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }